import { useRecoilState, useSetRecoilState } from "recoil"
import { chargesAtom, crudChargesAtom } from "../atoms/charges.atoms"
import ChargesAPI from "../api/charges.api"
import toast from "react-hot-toast"


const useChargesAction = () =>{

    const setChargesCrud = useSetRecoilState(crudChargesAtom)
    const setCharges =  useSetRecoilState(chargesAtom)

    const createCharge = async(data, cb) =>{
        setChargesCrud((prevValues) => ({ ...prevValues, loading: true }));
        try {
          const response = await ChargesAPI.createCharge(data);
          if (cb) {
            cb(response);
          }
          setChargesCrud((prevValues) => ({
            ...prevValues,
            loading: false,
            status: response.status,
          }));
        } catch (error) {
            setChargesCrud((prevValues) => ({
            ...prevValues,
            loading: false,
            message: "Error al crear cargo",
            status: 500,
            error: JSON.stringify(error),
          }));
        }
      };
                                                                               
    const paginateCharges = async ({ page = 1, limit = 10, search = null, clientId = '', isFiltered = false }, cb) => {
      setCharges((prevValues) => ({ ...prevValues, loading: true }));
      try {
        let params = null;
        params = {
          clientId,
          paginationParams: { page, limit,
           },
        };

        if (search) params.paginationParams.search = [search];
        const { data } = await ChargesAPI.paginateCharge(params);

        if(isFiltered){
          const filteredCharges = data.data.filter((charges)=> {
            return charges.currentClientsId !== ""
          })
          if (cb) {
            cb(data);
          }
            setCharges((prevValues) => ({ ...prevValues, loading: false, payload: filteredCharges || [], total: data?.total || 0 }));
        } else {
          if(cb){
            cb(data)
          }
            setCharges((prevValues) => ({ ...prevValues, loading: false, payload: data?.data || [], total: data?.total || 0 }));
        }
      } catch (error) {
        setChargesCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al listar perfiles profesionales",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    }

    const deleteCharge = async(id, cb)=>{
      setChargesCrud((prevValues) => ({ ...prevValues, loading: true }));
      try {
        const response = await ChargesAPI.deleteCharge({id});
        if(cb){
          cb(response)
        }
        setChargesCrud((prevValues) => ({ ...prevValues, loading: false, status: response.status })); 
      } catch (error) {
        toast.error('Error al eliminar perfil profesional]', {duration:4000})
        setChargesCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al borrar pefil profesional",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    }

    const editCharge= async(data, cb)=>{
      setChargesCrud((prevValues) => ({ ...prevValues, loading: true }));
      try {
        const response = await ChargesAPI.editCharge(data);
        if(cb){
          cb(response)
        }
        setChargesCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          status: response.status,
        }));

      } catch (error) {
        toast.error('Error al editar perfil profesional]', {duration:4000})
        setChargesCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al borrar pefil profesional",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    }

    const listCharges = async(params, cb) =>{
      setChargesCrud((prevValues) => ({ ...prevValues, loading: true }));
      try {
        const response = await ChargesAPI.listCharges(params)
        setChargesCrud((prevValues) => ({ ...prevValues, loading: false }));
        return response;
      } catch (error) {
        toast.error('Error al listar Cargos', {duration:4000})
        setChargesCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al listar cargos profesionales",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    }
    

    return {
        createCharge,
        paginateCharges,
        deleteCharge,
        editCharge,
        listCharges
    }
    
}

export {useChargesAction};